module.exports = __webpack_public_path__ + "fonts/KohinoorTelugu-Bold.401de3b7.ttf";